// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"df9bb0ac","667":"fb33337c","977":"ed240f18"}[chunkId] + ".chunk.js";
};